/**
 * Page footer — copyright + legal links + social icons. Pure markup.
 */
export function renderFooter() {
    const year = new Date().getFullYear();
    return `
        <div>
            <section class="copyright_bar">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-8 col-lg-8 col-info">
                            <img class="footer_logo" src="https://cdn.snapplify.com/1.0.29/img/logo.svg" border="0" alt="Snapplify"/>
                            <p>&copy; 2013 - ${year} Snapplify. All Rights Reserved.</p>
                            <ul>
                                <li><a href="https://shop.snapplify.com/page/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>&nbsp;&nbsp;|&nbsp;&nbsp;</li>
                                <li><a href="https://www.snapplify.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>&nbsp;&nbsp;|&nbsp;&nbsp;</li>
                                <li><a href="https://shop.snapplify.com/page/returnrefund-policy" target="_blank" rel="noopener noreferrer">Return/Refund Policy</a></li>
                            </ul>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4 social_icons">
                            <a class="social_icon" href="https://www.linkedin.com/company/snapplify" target="_blank" rel="noopener noreferrer"><img src="https://cdn.snapplify.com/1.0.29/img/linkedin_icon.svg" border="0" alt="Snapplify on LinkedIn"/></a>
                            <a class="social_icon" href="https://www.instagram.com/snapplify" target="_blank" rel="noopener noreferrer"><img src="https://cdn.snapplify.com/1.0.29/img/instagram_icon.svg" border="0" alt="Snapplify on Instagram"/></a>
                            <a class="social_icon" href="https://twitter.com/Snapplify" target="_blank" rel="noopener noreferrer"><img src="https://cdn.snapplify.com/1.0.29/img/twitter_icon.svg" border="0" alt="Snapplify on Twitter"/></a>
                            <a class="social_icon" href="https://www.facebook.com/snapplify" target="_blank" rel="noopener noreferrer"><img src="https://cdn.snapplify.com/1.0.29/img/facebook_icon.svg" border="0" alt="Snapplify on Facebook"/></a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;
}
